<template>
  <i
    v-accessibility-focus="toggleFullscreen"
    :aria-label="$t('accessibility.player.fullscreen')"
    class="o-icon o-icon--maximize"
  ></i>
</template>
<script>
  import FullscreenToggleMixin from '@/shared/components/player/mixins/fullscreen-toggle';

  export default {
    name: 'UiPlayerFullscreenBtn',
    mixins: [
      FullscreenToggleMixin,
    ],
  };
</script>
